<style lang="scss" src='./AlertDetails.scss' scoped></style>
<template src="./AlertDetails.html"></template>

<script>
import { mapMutations, mapState } from "vuex";
import SensorChart from "../../chart/SensorChart";
import GwRing from "@/components/gwRing/GwRing.vue";
import TaskDetails from '@/views/task/details/TaskDetails.vue';

export default {
  name: "AlertDetails",
  props: {
    sensor: {
      requiered: false,
    },
    alert: {
      requierd: true,
    },
    station:{
      requierd: false,
    }
  },
  data() {
    return {
      ico_measurement: null,
    };
  },
  components: {
    SensorChart,
    GwRing,
    TaskDetails,
  },
  watch: {},

  computed: {
    ...mapState("sensors", ["showAlertList", "ringsData"]),
    ...mapState('sensors', {
      rssiRanges: (state) => state.rssiRanges,
    }),
    ...mapState(['course']),
    isCourseType(){
      if( (this.course.facility_type && this.course.facility_type.is_golf_course) 
        || !this.course.facility_type){
        return true;
      }else{
        return false;
      }
    },
    getRingData() {
      if (this.consts.AlertType[this.alert.alert_type.alert_type_id].key == this.consts.AlertType['SENSOR_TRANSITION'].key) {
        return this.ringsData[this.consts.AlertType['MOISTURE'].key]
      }
      return this.ringsData[this.consts.AlertType[this.alert.alert_type.alert_type_id].key]
    },
  },

  methods: {
    getRssiIcon(alert) {
      // eslint-disable-next-line
      return require(`@/assets/img/sensor/${this.G_getRssiIcon(alert.sensor, this.rssiRanges)}`);
    },

    getProbeDisconnectedIcon() {
      return require(`@/assets/img/alert/UNPLUGGED.png`);
    },

    showAlertDetails() {
      this.setShowAlertList(true);
    },

    getThresholdViolation(alert) {
      let minMax = "min_";
      const alertType = this.consts.AlertType[alert.alert_type_id];
      if (alert.violation === "READING_HIGH") {
        minMax = "max_";
      }
      return this.G_getMeasurement({
        val: alert.sensor.threshold[minMax + alertType.key],
        uom: alert.alert_type.uom,
        addUnit: true,
        invertUOM: false,
      });
    },

    async setIcoMeasurement() {
      const alertKey = this.consts.AlertType[this.alert.alert_type.alert_type_id].id;
      this.ico_measurement = await require(`@/assets/img/alert/${alertKey}_fill.png`);
    },

    ...mapMutations("sensors", ["setShowAlertList"]),
  },

  beforeCreate() {},

  created() {},

  mounted() {
    this.setIcoMeasurement();
  },
};
</script>
